import {Environment} from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://k.api.mabble.co.za'
};
